import React, { forwardRef, useImperativeHandle } from "react";
import { usePaystackPayment } from "react-paystack";
import { PAYSTACK_PUBLIC_KEY } from "../../Constants/main";
import { loggedUser } from "../../Constants/menus";
import Api from "../../Server/Api";

const api = new Api();

export const PaymentButton = forwardRef(({ amount = 150, id, email, successEndpoint, closeCallback }, ref) => {
	const [accepting, setAccepting] = React.useState();

	const config = {
		email: email || loggedUser?.email,
		amount: amount * 100,
		publicKey: PAYSTACK_PUBLIC_KEY,
	};
	const initializePayment = usePaystackPayment(config);

    const update = (status, reference=null) => {
        api.put({ endpoint: successEndpoint || `/appointments/${id}/payment_status/`, data: { status, reference: reference?.reference } })
        .then((res) => {
            setAccepting(false)
            if(res?.status) window.location = ""
        })
    }

	// you can call this function anything
	const onSuccess = (reference) => {
		// Implementation for whatever you want to do with reference and after success call.
        update("SUCCESS", reference);
	};

	// you can call this function anything
	const onClose = () => {
		// implementation for  whatever you want to do when the Paystack dialog closed.
		closeCallback && closeCallback()
        // update("FAILED");
	};


	useImperativeHandle(ref, () => ({
		pay() {
			initializePayment(onSuccess, onClose);
		},
	  }));

	return (
		<button
			onClick={() => {
				initializePayment(onSuccess, onClose);
			}}
			className={`button h-button is-primary is-outlined is-pushed-mobile`}
		>
		    {accepting?"PROCESSING...":"PAY NOW"}	
		</button>
	);
});
